import { Directive, ElementRef, Renderer2, Input, NgModule } from '@angular/core';
import FontFaceObserver from 'fontfaceobserver';

import * as ɵngcc0 from '@angular/core';
class WatermarkHandler {
    constructor(_el, _renderer) {
        this.DEFAULT_FONT_FAMILY = 'Arial';
        this.DEFAULT_OPTIONS = {
            text: 'ngx-watermark',
            width: 300,
            height: 100,
            fontFamily: this.DEFAULT_FONT_FAMILY,
            fontSize: '18px',
            fontWeight: "normal",
            color: '#999999',
            alpha: 0.5,
            degree: -45,
            lineHeight: 24,
            textAlign: 'center',
            textBaseline: 'middle',
            backgroundRepeat: 'repeat',
            backgroundPosition: '0% 0%',
        };
        this.WEB_SAFE_FONT = [
            "Georgia", "Palatino Linotype", "Book Antiqua", "Palatino", "Times New Roman", "Times", "serif",
            "Arial", "Helvetica", "Arial Black", "Gadget", "Comic Sans MS", "cursive", "Impact", "Charcoal", "Lucida Sans Unicode", "Lucida Grande", "Tahoma", "Geneva", "Trebuchet MS", "Verdana", "sans-serif",
            "Courier New", "Courier", "Lucida Console", "Monaco", "monospace" // Monospace Fonts
        ];
        this._el = _el;
        this._renderer = _renderer;
    }
    generateWatermark(_ops) {
        let options = Object.assign({}, this.DEFAULT_OPTIONS, _ops);
        if (this.isWebSafeFont(options.fontFamily)) {
            this.processStyleFromOptions(options);
        }
        else {
            let font = new FontFaceObserver(options.fontFamily);
            font.load().then(() => {
                this.processStyleFromOptions(options);
            }).catch(() => {
                options = Object.assign({}, options, { fontFamily: this.DEFAULT_FONT_FAMILY });
                this.processStyleFromOptions(options);
            });
        }
    }
    processStyleFromOptions(_ops) {
        this.setHTMLElementStyle(['background-image', `url(${this.createDataUrl(_ops)})`]);
        this.setHTMLElementStyle(['background-repeat', _ops.backgroundRepeat]);
        this.setHTMLElementStyle(['background-position', _ops.backgroundPosition]);
    }
    isWebSafeFont(_font) {
        return this.WEB_SAFE_FONT.indexOf(_font) != -1;
    }
    createDataUrl(options) {
        const width = options.width;
        const height = options.height;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.globalAlpha = 0;
        ctx.fillRect(-0.5 * width, -0.5 * height, width, height);
        ctx.font = `${options.fontWeight} ${options.fontSize} ${options.fontFamily}`;
        ctx.fillStyle = options.color;
        ctx.globalAlpha = options.alpha;
        ctx.textAlign = options.textAlign;
        ctx.textBaseline = options.textBaseline;
        ctx.translate(0 + 0.5 * width, 0 + 0.5 * height);
        ctx.rotate((options.degree * Math.PI) / 180);
        this.generateMultiLineText(ctx, options.text, width, options.lineHeight, 0, 0);
        return canvas.toDataURL();
    }
    generateMultiLineText(_ctx, _text, _width, _lineHeight, x, y) {
        let words = _text.split('\n');
        let line = '';
        for (var n = 0; n < words.length; n++) {
            line = words[n];
            _ctx.fillText(line, x, y);
            y += _lineHeight;
        }
    }
    setHTMLElementStyle([name, value]) {
        this._renderer.setStyle(this._el.nativeElement, name, value);
    }
}

class NgxWatermarkDirective {
    constructor(_el, _renderer) {
        this._el = _el;
        this._renderer = _renderer;
        this.watermarkHandler = new WatermarkHandler(this._el, this._renderer);
    }
    ngOnChanges() {
        this.watermarkHandler.generateWatermark(this.options);
    }
}
NgxWatermarkDirective.ɵfac = function NgxWatermarkDirective_Factory(t) { return new (t || NgxWatermarkDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NgxWatermarkDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxWatermarkDirective, selectors: [["", "ngxWatermark", ""]], inputs: { options: ["ngxWatermark", "options"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
NgxWatermarkDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
NgxWatermarkDirective.propDecorators = {
    options: [{ type: Input, args: ['ngxWatermark',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxWatermarkDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxWatermark]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { options: [{
            type: Input,
            args: ['ngxWatermark']
        }] }); })();

class NgxWatermarkModule {
}
NgxWatermarkModule.ɵfac = function NgxWatermarkModule_Factory(t) { return new (t || NgxWatermarkModule)(); };
NgxWatermarkModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxWatermarkModule });
NgxWatermarkModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxWatermarkModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxWatermarkDirective],
                imports: [],
                exports: [NgxWatermarkDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxWatermarkModule, { declarations: [NgxWatermarkDirective], exports: [NgxWatermarkDirective] }); })();

/*
 * Public API Surface of ngx-watermark
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxWatermarkDirective, NgxWatermarkModule };

